import {
  jb_service_navigation_item_css_default
} from "./chunk.74OET4G4.js";
import {
  Linkable
} from "./chunk.3FKBYJ4V.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-service-navigation-item/jb-service-navigation-item.ts
var JbServiceNavigationItem = class extends Linkable(r) {
  updated(_changedProperties) {
    super.updated(_changedProperties);
    if (this.clientHeight === 0) {
      this.renderRoot.querySelector("span").tabIndex = -1;
    }
  }
  getIconComponent(iconName) {
    switch (iconName) {
      case "contact-icon":
        import("../components/icons/jb-contact-icon/jb-contact-icon.js").then();
        return ke`<jb-contact-icon><slot></slot></jb-contact-icon>`;
      case "e-service-icon":
        import("../components/icons/jb-e-service-icon/jb-e-service-icon.js").then();
        return ke`<jb-e-service-icon><slot></slot></jb-e-service-icon>`;
      case "legal-icon":
        import("../components/icons/jb-legal-icon/jb-legal-icon.js").then();
        return ke`<jb-legal-icon><slot></slot></jb-legal-icon>`;
      default:
        return ke`<slot></slot>`;
    }
  }
  render() {
    return ke`
      <span
        role="listitem"
        tabindex="0"
        class=${Rt({
      "mobile-menu": this.parentElement?.slot === "",
      "first-element": this.previousElementSibling === null,
      "service-navigation-item": true,
      "service-navigation-item--animate-left": true
    })}
      >
        <a
          data-linkable
          class="service-navigation-item__text"
          aria-label="${this.ariaLabels?.label ?? D}"
        >
          ${this.getIconComponent(this.icon)}
        </a>
      </span>
    `;
  }
};
JbServiceNavigationItem.styles = [reset_css_default, jb_service_navigation_item_css_default];
JbServiceNavigationItem.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Object })
], JbServiceNavigationItem.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbServiceNavigationItem.prototype, "icon", 2);
__decorateClass([
  n()
], JbServiceNavigationItem.prototype, "trackingLabel", 2);
JbServiceNavigationItem = __decorateClass([
  customElement("jb-service-navigation-item")
], JbServiceNavigationItem);

export {
  JbServiceNavigationItem
};
